import { z } from 'zod';
export const ClaimsV2ParameterSchema = z.enum(['CLAIMS_BASE_URL']);
export const ClaimsV2ParameterEnum = ClaimsV2ParameterSchema.enum;
